import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabase";

const QuickMessageButton = ({ userId, userName, className = "", buttonText }) => {
  const navigate = useNavigate();

  const startConversation = async () => {
    try {
      const { data: currentUser } = await supabase.auth.getUser();
      if (!currentUser?.user) {
        alert("Please log in to send messages");
        return;
      }

      const currentUserId = currentUser.user.id;

      // Check if conversation already exists
      const { data: existingConv } = await supabase
        .from("conversations")
        .select("id")
        .or(`and(participant_one_id.eq.${currentUserId},participant_two_id.eq.${userId}),and(participant_one_id.eq.${userId},participant_two_id.eq.${currentUserId})`)
        .single();

      if (!existingConv) {
        // Create new conversation
        await supabase
          .from("conversations")
          .insert({
            participant_one_id: currentUserId,
            participant_two_id: userId
          });
      }

      // Navigate to messages with user selected
      navigate(`/messages?user=${userId}`);
    } catch (error) {
      console.error("Error starting conversation:", error);
    }
  };

  return (
    <button
      onClick={startConversation}
      className={`quick-message-btn ${className}`}
    >
      {buttonText ? (
        buttonText
      ) : (
        `💬 Message ${userName}`
      )}
    </button>
  );
};

export default QuickMessageButton;